<template>
  <b-card>
    <b-row>
      <b-col lg="12">
        <!-- .name -->

        <b-row>
          <b-col lg="6">
            <b-form-group
              id="input-group-1"
              :label="$t('settings.title')"
              label-for="input-1"
            >
              <b-form-input
                id="input-1"
                v-model="newItem.title"
                type="text"
                :placeholder="$t('settings.title')"
              >
              </b-form-input>
            </b-form-group>
          </b-col>
          <b-col lg="3">
            <b-form-group
              id="input-group-1"
              :label="$t('settings.logo')"
              label-for="input-1"
            >
              <b-form-file
                v-model="newItem.logo"
                placeholder="Choose a logo or drop it here..."
                drop-placeholder="Drop file here..."
                @change="onFileChange"
                accept="image/*"
              />
            </b-form-group>
          </b-col>
          <b-col lg="3">
            <b-img
              v-bind="mainProps"
              alt="Rounded image"
              class="d-inline-block mr-1 mb-1"
            />
          </b-col>
          <b-col lg="12">
            <b-form-group
              id="input-group-1"
              :label="$t('settings.description')"
              label-for="input-1"
            >
              <ckeditor
                id="input-1"
                v-model="newItem.description"
                 :config="{ contentsLangDirection: 'ltr',versionCheck : false }"
              >
              </ckeditor>
            </b-form-group>
          </b-col>
          <b-col lg="6">
            <b-form-group
              id="input-group-1"
              :label="$t('settings.keywords')"
              label-for="input-1"
            >
              <b-input-group>
                <b-input-group-prepend is-text>
                  <feather-icon icon="TagIcon" />
                </b-input-group-prepend>
                <b-form-input
                  id="input-1"
                  v-model="newItem.keywords"
                  type="text"
                  :placeholder="$t('settings.keywords')"
                >
                </b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>

          <b-col lg="6">
            <b-form-group
              id="input-group-1"
              :label="$t('settings.address')"
              label-for="input-1"
            >
              <b-input-group>
                <b-input-group-prepend is-text>
                  <feather-icon icon="MapPinIcon" />
                </b-input-group-prepend>
                <b-form-input
                  id="input-1"
                  v-model="newItem.address"
                  type="text"
                  :placeholder="$t('settings.address')"
                >
                </b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col lg="6">
            <b-form-group
              id="input-group-1"
              :label="$t('settings.phone')"
              label-for="input-1"
            >
              <b-input-group>
                <b-input-group-prepend is-text>
                  <feather-icon icon="PhoneIcon" />
                </b-input-group-prepend>
                <b-form-input
                  id="input-1"
                  v-model="newItem.phone"
                  type="text"
                  :placeholder="$t('settings.phone')"
                >
                </b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col lg="6">
            <b-form-group
              id="input-group-1"
              :label="$t('settings.email')"
              label-for="input-1"
            >
              <b-input-group>
                <b-input-group-prepend is-text>
                  <feather-icon icon="MailIcon" />
                </b-input-group-prepend>
                <b-form-input
                  id="input-1"
                  v-model="newItem.email"
                  type="text"
                  :placeholder="$t('settings.email')"
                >
                </b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col lg="6">
            <b-form-group
              id="input-group-1"
              :label="$t('settings.youtube')"
              label-for="input-1"
            >
              <b-input-group>
                <b-input-group-prepend is-text>
                  <feather-icon icon="YoutubeIcon" />
                </b-input-group-prepend>
                <b-form-input
                  id="input-1"
                  v-model="newItem.youtube"
                  type="text"
                  :placeholder="$t('settings.youtube')"
                >
                </b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col lg="6">
            <b-form-group
              id="input-group-1"
              :label="$t('settings.instagram')"
              label-for="input-1"
            >
              <b-input-group>
                <b-input-group-prepend is-text>
                  <feather-icon icon="InstagramIcon" />
                </b-input-group-prepend>
                <b-form-input
                  id="input-1"
                  v-model="newItem.instagram"
                  type="text"
                  :placeholder="$t('settings.instagram')"
                >
                </b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col lg="6">
            <b-form-group
              id="input-group-1"
              :label="$t('settings.twitter')"
              label-for="input-1"
            >
              <b-input-group>
                <b-input-group-prepend is-text>
                  <feather-icon icon="TwitterIcon" />
                </b-input-group-prepend>
                <b-form-input
                  id="input-1"
                  v-model="newItem.twitter"
                  type="text"
                  :placeholder="$t('settings.twitter')"
                >
                </b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col lg="6">
            <b-form-group
              id="input-group-1"
              :label="$t('settings.facebook')"
              label-for="input-1"
            >
              <b-input-group>
                <b-input-group-prepend is-text>
                  <feather-icon icon="FacebookIcon" />
                </b-input-group-prepend>
                <b-form-input
                  id="input-1"
                  v-model="newItem.facebook"
                  type="text"
                  :placeholder="$t('settings.facebook')"
                >
                </b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col lg="6">
            <b-form-group
              id="input-group-1"
              :label="$t('settings.copyright')"
              label-for="input-1"
            >
              <b-input-group prepend="@">
                <b-form-input
                  id="input-1"
                  v-model="newItem.copyright"
                  type="text"
                  :placeholder="$t('settings.copyright')"
                >
                </b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col lg="6">
            <b-button block variant="info" @click="addNewRoutes()">
              <i class="fa fa-plus" /> {{ $t("site.addNewRoutes") }}
            </b-button>
          </b-col>
        </b-row>
        <hr />
        <b-row>
          <b-col lg="6">
            <b-button block variant="primary" @click="submit()">
              <i class="fa fa-plus" /> {{ $t("site.save") }}
            </b-button>
          </b-col>
          <b-col lg="6">
            <b-button block @click="goToTable()" variant="success">
              <i class="fas fa-ban"></i> {{ $t("site.cancel") }}
            </b-button>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import SettingController from "@/Controllers/SettingController";
const ctr = new SettingController();
export default {
  name: "TagsForm",
  components: {},
  data() {
    return {
      file: {},
      newItem: {},
      mainProps: {
        blank: true,
        blankColor: "#777",
        width: 75,
        height: 75,
        class: "m1",
      },
      url: null,
    };
  },
  async created() {
    const res = await ctr.GetAll({ filter: "user_id|0" });
    res.forEach((element) => {
      this.newItem[element.key] = element.value;
    });
    const logo = res.find((a) => a.key == "logo");
    if (logo) {
      this.mainProps.blank = false;
      this.mainProps.src = logo.logo_path;
    }

    // this.$forceUpdate();
  },
  methods: {
    async goToTable() {
      this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
      this.$parent.$parent.firstTab();
    },
    async submit() {
      let ret = await ctr.From(this.newItem, "FormData");
      if (ret) {
        // this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
        // this.$parent.$parent.firstTab();
      }
    },
    async addNewRoutes() {
      await ctr.addNewRoutes({
        data: this.$router.options.routes.map((a) => {
          return { name: a.name, path: a.path };
        }),
      });
    },
    onFileChange(e) {
      const file = e.target.files[0];
      this.mainProps.blank = false;
      this.mainProps.src = URL.createObjectURL(file);
      this.$forceUpdate();
    },
  },
};
</script>

<style>
</style>